module.exports = __webpack_public_path__ + "static/img/Bag.01260ae.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/Bag.png
// module id = XCqr
// module chunks = 1